import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { FiLogOut } from "react-icons/fi";
import UserLogout from "../../Pages/UserLogut/UserLogout";
import "./UserHeader.css";

const UserHeader = () => {
  const location = useLocation();
  const [showLogout, setShowLogout] = useState(false);

  const titles = {
    "/user/dashboard": "Dashboard",
    "/user/products": "Product List",
    "/user/add-reference": "Add Reference",
    "/user/history": "History",
    "/user/login": "Login",
    "/user/otp": "OTP Verification",
    "/user/dashboard/references": "Total References",
  };

  const title = titles[location.pathname] || "Dashboard";

  return (
    <>
      <header className="user-header">
        <h3>{title}</h3>
        <div
          className="logout-icon"
          onClick={() => setShowLogout(true)}
          style={{ cursor: "pointer" }}
        >
          <FiLogOut size={22} />
        </div>
      </header>
      {showLogout && (
        <UserLogout onClose={() => setShowLogout(false)} />
      )}
    </>
  );
};

export default UserHeader;